/**
 * Tính số nộp kỳ này
 */
export default {
  //Bảo hiểm
  All: 1,
  //KPCĐ
  ExcludeInsurance: 2,
};
